import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';
import { transferOrderGridProperties } from '../../data/transfer-order-properties';
import UserDateTimezoneFormat from '../../../../../components/user-date-timezone-format';
import type { GridColumn } from './types';

const name = <FormattedMessage {...messages.orderDateColumnHeader} />;

export const orderDateColumn: GridColumn = {
  name,
  render: (data) => {
    const { orderDate } = data;
    if (!orderDate) return null;
    return <UserDateTimezoneFormat dateTime={orderDate as string} />;
  },
  id: transferOrderGridProperties.orderDate,
};
